import classnames from "classnames";

import ContentBlockLink from "./contentListBlockLink/contentListBlockLink.component";

import "./contentListBlock.scss";

type Link = {
    url: string;
    name: string;
};

type Props = {
    content: {
        title: string;
        icon: string;
        links: [Link];
    };
};

const ContentBlock = ({ content }: Props) => {
    return (
        <div
            className={classnames(
                "contentBlockList",
                "align-items-center",
                "d-flex",
                "flex-column",
                "justify-content-start",
                "p-1",
                "text-center"
            )}
        >
            {/** biome-ignore lint/a11y/useHeadingContent: <TODO> */}
            <h2
                className={classnames(
                    "contentBlockList__icon",
                    "mb-2",
                    content.icon
                )}
            />
            <h5 className={"text-uppercase"}>{content.title}</h5>
            {content.links?.map((link: Link, index: number) => (
                <ContentBlockLink
                    key={index}
                    link={link}
                />
            ))}
        </div>
    );
};

export default ContentBlock;
